<template>
  <v-card elevation="0" class="mx-auto">
    <h1 class="pa-4">Características principales</h1>

    <v-container>
      <v-row v-for="(items, i) in productoCaracteristicas" :key="i" dense>
        <v-col lg="3" md="3" sm="4" xs="4" class="pa-0">
          <v-tooltip v-if="showTooltip(items.name)" max-width="300" top>
            <template v-slot:activator="{ on }">
              <v-card
                color="#EEEEEE"
                height="30px"
                class="pa-2 rounded-0"
                elevation="1"
                v-on="on"
              >
                <div>
                  <p
                    class="font-weight-black text-xs-caption text-sm-caption text-md-h6 text-lg-h6 text-xl-h5"
                  >
                    {{ itemsName(items.name) }}
                  </p>
                </div>
              </v-card>
            </template>

            <span>{{ items.name }}</span>
          </v-tooltip>

          <v-card
            color="#EEEEEE"
            height="30px"
            class="pa-2 rounded-0"
            elevation="1"
            v-if="!showTooltip(items.name)"
          >
            <div>
              <p
                class="font-weight-black text-xs-caption text-sm-caption text-md-h6 text-lg-h6 text-xl-h5"
              >
                {{ itemsName(items.name) }}
              </p>
            </div>
          </v-card>
        </v-col>

        <v-col lg="9" md="9" sm="8" xs="8" class="pa-0">
          <v-tooltip v-if="showTooltip2(items.value)" max-width="300" top>
            <template v-slot:activator="{ on }">
              <v-card
                height="30px"
                color="#F5F5F5"
                class="pa-2 rounded-0"
                elevation="1"
                v-on="on"
              >
                <div>
                  <p>{{ itemsDescrip(items.value) }}</p>
                </div>
              </v-card>
            </template>

            <span>{{ items.value }}</span>
          </v-tooltip>

          <v-card
            height="30px"
            color="#F5F5F5"
            class="pa-2 rounded-0"
            elevation="1"
            v-if="!showTooltip2(items.value)"
          >
            <div>
              <p>{{ itemsDescrip(items.value) }}</p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "child_ProductCharacteristic",

  components: {},

  data() {
    return {
      info: [{ id: "", name: "", value: "" }],
      title: "",
    };
  },

  props: {
    productoCaracteristicas: { type: Array },
    sendSnack: { type: Function },
  },

  methods: {
    showTooltip(name) {
      return name.length > 15;
    },

    itemsName: function (name) {
      return name.length > 15 ? `${name.substring(0, 15)}...` : name;
    },

    showTooltip2(name) {
      return name.length > 25;
    },

    itemsDescrip: function (name) {
      return name.length > 25 ? `${name.substring(0, 25)}...` : name;
    },
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},
};
</script>

<style>
.imagen {
  width: 340px;
  max-height: 250px;
  margin-left: 15px;
  margin-top: 10px;
}
</style>
